export const SHIPPING_METHOD_CODE_OCA = 'oca-partner-ar';
